import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceLineItem, InvoiceType } from 'models/invoice';
import { TableRow, TableCell, Link, Button, Box } from '@mui/material';
import { formatCurrency } from 'utils/format';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoneIcon from '@mui/icons-material/Done';
import { Order } from 'models/order';

type InvoiceLineItemProps = {
    invoiceLineItem: InvoiceLineItem;
    isDentist: boolean;
    invoiceType: InvoiceType;
    currency: string;
    isCertificationEnabled: boolean;
    openPriceSpecDialog: () => void;
    openConfirmDialog: () => void;
};
const InvoiceLineItemComponent: FC<InvoiceLineItemProps> = ({
    invoiceLineItem,
    isDentist,
    invoiceType,
    currency,
    isCertificationEnabled,
    openPriceSpecDialog,
    openConfirmDialog,
}: InvoiceLineItemProps) => {
    const { t: translate } = useTranslation(['orders', 'common']);

    return (
        <TableRow>
            {isCertificationEnabled && invoiceType !== InvoiceType.SINGLE ? (
                <TableCell sx={{ maxWidth: '100px' }}>
                    {isDentist && invoiceLineItem.order ? (
                        (invoiceLineItem.order as Order)?.isCertified ? (
                            <Box
                                p={0.5}
                                sx={{ color: 'success.main', cursor: 'pointer' }}
                                display="flex"
                                justifyItems="center"
                                onClick={() => openConfirmDialog()}
                            >
                                <CheckCircleIcon fontSize="small" />
                                <Box ml={0.5}>{translate('orders:CERTIFIED')}</Box>
                            </Box>
                        ) : (
                            <Button size="small" startIcon={<DoneIcon />} onClick={() => openPriceSpecDialog()}>
                                {translate('orders:CERTIFY')}
                            </Button>
                        )
                    ) : undefined}
                </TableCell>
            ) : undefined}

            <TableCell>
                {invoiceLineItem.order ? (
                    <Link target="_blank" href={`/order-details/${(invoiceLineItem.order as Order)?._id}/main-view`}>
                        {invoiceLineItem.description}
                    </Link>
                ) : (
                    invoiceLineItem.description
                )}
            </TableCell>
            <TableCell align="right">{invoiceLineItem.quantity || '-'}</TableCell>
            <TableCell align="right">{formatCurrency(invoiceLineItem.itemPrice, currency)}</TableCell>
            <TableCell align="right">
                {formatCurrency(invoiceLineItem.itemPrice * (invoiceLineItem.quantity || 1), currency)}
            </TableCell>
            <TableCell align="right">{formatCurrency(invoiceLineItem.itemVat, currency)}</TableCell>
            <TableCell align="right">{formatCurrency(invoiceLineItem.totalIncVat, currency)}</TableCell>
        </TableRow>
    );
};

export default InvoiceLineItemComponent;
